import React, {FC, useEffect} from "react";
import {Location} from "../../../../components/BillingLocationSelector";
import styles from "../PostJob.module.scss";
import {Button} from "@material-ui/core";
import {Country} from "../PostJob.utils";
import ModalTitleContainer from "../../../../components/Modal/components/ModalTitleContainer";
import ModalShiftDescriptionContainer from "../../../../components/Modal/components/ModalShiftDescriptionContainer";
import {Type} from "utils/types";

interface ShiftIsLiveModalProps {
    availableHygienists: any,
    role: Type,
    location: Location,
    from: string,
    to: string,
    onCloseButtonClick: (e: any) => void
}

export const ShiftIsLiveModal: FC<ShiftIsLiveModalProps> = ({availableHygienists, role, location, from, to, onCloseButtonClick}) => {
    const roleString = role === Type.Hygienist ? 'Dental Hygienist' : 'Dental Assistant'

    let title = 'Nicely done - your temping shift has been posted!'
    let description = `We're alerting `
        + `every ${roleString} within ${location.country === Country.Canada ? '110km' : '70mi'} of`
        + ` your office about your shift.\n\n`
        + `So keep an eye on your inbox (${location.email}) for offers from great matches.\n\n`
        + `If you need to edit the shift details, just tap on the date in your home calendar screen.\n\n`

    if(availableHygienists?.length) {
        title = 'Insta-Book a ' + roleString;
        description = `Your shift was successfully posted to all available ${roleString}s in your area.\n\n`
            + `And great news!  There are ${roleString}s who indicated they are available for your shift that you can book right now without waiting.\n`
            + `We'll take you to that list now so you can browse their profiles. If you see one you want to book right now, you can do that!\n\n`
    }

    return (
        <>
            <ModalTitleContainer title={title} onClose={onCloseButtonClick} />

            <div className={styles.description}>
                {description}
            </div>

            <ModalShiftDescriptionContainer
                header={location.practiceName}
                address={location.address}
                from={from}
                to={to}
            />

            <Button
                variant="contained"
                color="primary"
                size="large"
                id="continue-button"
                className="bigButtonInNewStyle"
                onClick={onCloseButtonClick}
            >
                OK
            </Button>
        </>
    );
}